/**
 * Formatting for the profile area.
 *
 * Templates render finished values; the arithmetic and the string assembly
 * happen here. Dates follow the portal convention of DD-Mmm-YY - never purely
 * numeric - with the clock time appended where a moment (rather than a day) is
 * being shown.
 */

// The DD-Mmm-YY rule itself lives in /helpers/date-formatting.js — it is a portal-wide
// convention, not a profile one, and three areas had grown their own copy of the month
// table. These two keep their names so the profile pages don't change.
import { formatDisplayDate, formatDisplayMoment } from "/helpers/date-formatting.js";



/**
 * A date as DD-Mmm-YY (e.g. 21-Jul-26).
 */
export function formatProfileDate(value)
{
	return formatDisplayDate(value);
}



/**
 * A moment as DD-Mmm-YY, h:mm AM/PM (e.g. "21-Jul-26, 8:42 AM") - what the
 * Security card shows for the last sign-in.
 */
export function formatProfileMoment(value)
{
	return formatDisplayMoment(value);
}



/**
 * The billing increment as "6 minutes (0.1 hours)".
 */
export function formatBillingIncrement(minutes)
{
	if (!minutes) return "—";

	const hours = Math.round((minutes / 60) * 100) / 100;

	return minutes + " minutes (" + hours + " hours)";
}



/**
 * The device line under the last sign-in: "MacBook Pro · macOS · London".
 * Parts that aren't known are dropped rather than showing an empty separator.
 */
export function formatSignInDevice(signIn)
{
	if (!signIn) return "";

	return [signIn.Device, signIn.OperatingSystem, signIn.Location]
		.filter((part) => part != null && part !== "")
		.join(" · ");
}



/**
 * The line under a person's name on the Identity card: "Partner · Corporate
 * Advisory". Either part may be missing while we have no API for it.
 */
export function formatIdentitySubtitle(identity)
{
	if (!identity) return "";

	return [identity.JobTitle, identity.Team]
		.filter((part) => part != null && part !== "")
		.join(" · ");
}



/**
 * The firm line in the sidebar and on the Identity card: "Harwood & Co · Partner".
 */
export function formatFirmLine(firmName, jobTitle)
{
	return [firmName, jobTitle]
		.filter((part) => part != null && part !== "")
		.join(" · ");
}
